export const PREFIX = `/api/${import.meta.env.VITE_API_VERSION || 'v1'}`;
